// extracted by mini-css-extract-plugin
export default {"office-dropdown":"staffDetails_office-dropdown__o96Hk"};